import React, { Component } from 'react';

class Services extends Component {

    constructor(props) {
        super(props);
        this.state = {
        }
    }

    render() {
        return (
            <React.Fragment>
                <section className="section" id="services">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-lg-7">
                                <div className="title text-center mb-5">
                                    <p className="text-uppercase text-muted mb-2 f-13 subtitle">Services</p>
                                    <h3>What We Do</h3>
                                    <p className="text-muted mt-3">Dantes remained confused and silent by this explanation of the thoughts which had unconsciously been working in his mind, or rather soul.</p>
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-lg-4">
                                <div className="services-box p-4">
                                    <div className="services-icon mb-3">
                                        <i className="pe-7s-monitor text-custom h1"></i>
                                    </div>
                                    <div className="services-desc">
                                        <h5 className="mb-3 f-18">Digital Design</h5>
                                        <p className="text-muted">It is a long established fact that a reader will be distracted by the content of a page when looking at its layout.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4">
                                <div className="services-box p-4">
                                    <div className="services-icon mb-3">
                                        <i className="pe-7s-notebook text-custom h1"></i>
                                    </div>
                                    <div className="services-desc">
                                        <h5 className="mb-3 f-18">Unlimited Colors</h5>
                                        <p className="text-muted">The European languages are members of the same family. Their separate existence is a myth music, sport</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4">
                                <div className="services-box p-4">
                                    <div className="services-icon mb-3">
                                        <i className="pe-7s-exapnd2 text-custom h1"></i>
                                    </div>
                                    <div className="services-desc">
                                        <h5 className="mb-3 f-18">Strategy Solutions</h5>
                                        <p className="text-muted">He lay on his armour-like back, and if he lifted his head a little he could see his brown belly, slightly domed</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-4">
                                <div className="services-box p-4">
                                    <div className="services-icon mb-3">
                                        <i className="pe-7s-repeat text-custom h1"></i>
                                    </div>
                                    <div className="services-desc">
                                        <h5 className="mb-3 f-18">Awesome Support</h5>
                                        <p className="text-muted">The wonderful serenity has taken of my these sweet mornings of spring which enjoy with my whole heart.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4">
                                <div className="services-box p-4">
                                    <div className="services-icon mb-3">
                                        <i className="pe-7s-albums text-custom h1"></i>
                                    </div>
                                    <div className="services-desc">
                                        <h5 className="mb-3 f-18">Truly Multipurpose</h5>
                                        <p className="text-muted">It showed a lady fitted out with a fur hat and boa who sat upright a heavy fur muff that covered the whole.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4">
                                <div className="services-box p-4">
                                    <div className="services-icon mb-3">
                                        <i className="pe-7s-upload text-custom h1"></i>
                                    </div>
                                    <div className="services-desc">
                                        <h5 className="mb-3 f-18">Easy to customize</h5>
                                        <p className="text-muted">The languages only differ in their grammar, their and their most common why a new common language</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </React.Fragment >
        );
    }
}

export default Services;


